export type BrandArrowKind = 'people' | 'communities' | 'world' | 'sun';

/** Intrinsic size of each 192 px cut (design-assets/build-brand-graphics.sh). */
const RATIO: Record<BrandArrowKind, [number, number]> = {
  people: [192, 148],
  communities: [192, 172],
  world: [192, 212],
  sun: [192, 249],
};

interface BrandArrowProps {
  kind: BrandArrowKind;
  /** Height utility; width follows the art. */
  size?: string;
  /** Decorative by default; pass alt to make it meaningful. */
  alt?: string;
  loading?: 'lazy' | 'eager';
  className?: string;
}

/**
 * One of the four arrows from the freshSTART logo (people, communities, world, sun),
 * cut from the master as brand art (PRP-15, D8). Used for the About pillars, the CTA
 * band climb and the loader.
 */
export function BrandArrow({ kind, size = 'h-12', alt, loading = 'lazy', className = '' }: BrandArrowProps) {
  const [w, h] = RATIO[kind];
  return (
    <img
      src={`/images/brand/arrow-${kind}-96.webp`}
      srcSet={`/images/brand/arrow-${kind}-96.webp 96w, /images/brand/arrow-${kind}-192.webp 192w`}
      sizes="96px"
      width={w}
      height={h}
      alt={alt ?? ''}
      aria-hidden={alt ? undefined : true}
      loading={loading}
      decoding="async"
      data-testid={`brand-arrow-${kind}`}
      className={`${size} w-auto select-none ${className}`}
    />
  );
}
